import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Linkedin } from "lucide-react";
import Logo from "@/components/common/Logo";
import { COMPANY, NAV, SERVICES } from "@/data/site";

const ICONS = { Facebook, Instagram, Linkedin };

export default function Footer() {
  return (
    <footer className="bg-gema-black border-t border-white/10" data-testid="site-footer">
      <div className="container-gema py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <Logo />
            <p className="mt-6 text-white/50 text-sm leading-relaxed max-w-xs">
              {COMPANY.description}
            </p>
            <div className="flex gap-3 mt-6">
              {COMPANY.social.map((s) => {
                const Icon = ICONS[s.icon];
                return (
                  <a
                    key={s.name}
                    href={s.url}
                    aria-label={s.name}
                    data-testid={`footer-social-${s.name.toLowerCase()}`}
                    className="flex h-10 w-10 items-center justify-center border border-white/15 text-white/70 hover:border-gema-red hover:text-gema-red transition-colors duration-300"
                  >
                    {Icon && <Icon className="h-4 w-4" />}
                  </a>
                );
              })}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold uppercase text-sm tracking-wider text-white mb-6">Navegación</h4>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-white/50 hover:text-gema-red transition-colors duration-300 text-sm">
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold uppercase text-sm tracking-wider text-white mb-6">Servicios</h4>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/servicios/${s.slug}`} className="text-white/50 hover:text-gema-red transition-colors duration-300 text-sm">
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold uppercase text-sm tracking-wider text-white mb-6">Contacto</h4>
            <ul className="space-y-4 text-sm text-white/50">
              <li className="flex items-start gap-3">
                <Phone className="h-4 w-4 text-gema-red mt-0.5 shrink-0" />
                <a href={`tel:${COMPANY.phoneRaw}`} className="hover:text-white transition-colors">{COMPANY.phone}</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-4 w-4 text-gema-red mt-0.5 shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-white transition-colors break-all">{COMPANY.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-4 w-4 text-gema-red mt-0.5 shrink-0" />
                <span>{COMPANY.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="h-4 w-4 text-gema-red mt-0.5 shrink-0" />
                <span>{COMPANY.hours[0].day}: {COMPANY.hours[0].time}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4">
          <p className="text-white/40 text-xs">
            © {new Date().getFullYear()} {COMPANY.fullName}. Todos los derechos reservados.
          </p>
          <p className="text-white/40 text-xs font-mono uppercase tracking-widest">
            Automotriz · Industrial · Naval
          </p>
        </div>
      </div>
    </footer>
  );
}
